import { useEffect } from "react";
import useContests from "../../models/contests/useContests";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import useAuth from "../../models/auth/useAuth";

import "./styles.scss";

const Contests = () => {
    const { contestList, fetchContestList } = useContests();
    const navigate = useNavigate();
    const { user: { restaurant_worker } } = useAuth();

    useEffect(() => {
        fetchContestList();
    }, []);

    return <div className="Contests">
        <div className="Contests__header">
            <h1>Concursos</h1>
            {restaurant_worker && restaurant_worker.is_admin && (
                <div className="Contests__header__actions">
                    <Button variant="contained" color="primary" onClick={() => navigate("./create")}>Crear Concurso</Button>
                </div>
            )}
        </div>
        {contestList.length === 0 && (
            <div className="Contests__empty">
                <h2>No hay concursos creados</h2>
            </div>
        )}
        <div className="Contests__list">
            {contestList.map((contest) => (
                <div key={contest.id} className="Contests__item" onClick={() => navigate(`./${contest.id}`)}>
                    <div className="Contests__item__name"><b>Restaurante:</b> {contest.restaurant_detail.name}</div>
                    <div className="Contests__item__date"><b>Fecha de inicio:</b> {format(contest.start_date, "dd/MM/yyyy")}</div>
                    <div className="Contests__item__date"><b>Fecha de fin:</b> {format(contest.end_date, "dd/MM/yyyy")}</div>
                    {contest.is_ongoing ? <div className="Contests__item__status Contests__item__status--ongoing">En curso</div> : <div className="Contests__item__status Contests__item__status--finished">Finalizado</div>}
                </div>
            ))}
        </div>
    </div>;
};

export default Contests;
